import { Auth as AuthPackage } from '@trustpilot/ecommscript-integrationappauth';
import { all, takeLatest, put } from 'redux-saga/effects';
import { matchesType } from '../helper';
import {
  trustpilot as actions,
  shop, pricing,
  businessModule,
  analytics as analyticsActions,
} from '../../../actions';

function* loggedStatus(): any {
  try {
    const isLogged = yield AuthPackage.isLoggedIn(
      process.env.REACT_APP_AuthenticationApiUrl!,
      process.env.REACT_APP_CookiesDomain!,
    );
    yield put(actions.setLoggedStatus(isLogged));
    if (isLogged) {
      yield put(businessModule.getId());
      yield put(shop.getStoreDetails());
      yield put(pricing.getPricing());
    }
  } catch (e) {
    yield put(actions.setLoggedStatus(false));
    yield put(analyticsActions.track('Error Occurred', {
      location: window.location.pathname,
      action: 'setting logged status failed',
      name: 'set-logged-status',
    }));
  }
}

function* trustpilot(): any {
  yield all([takeLatest(matchesType(actions.getLoggedStatus), loggedStatus)]);
}

export { trustpilot };
